<template>
  <div class="input-box">
    <label v-if="label !== undefined" class="label-text">{{label}}
      <a v-if="label != null & hrefText != null" :href="href" target="_blank">#{{hrefText}}</a>
    </label>
    <validation-provider name="baseInputEditValidationProvider" ref="validationInput" :rules="rules" v-slot="{errors, valid}">
      <div class="select-contain form-group mt-auto mb-auto" :class="errors.length > 0 ? 'error' : ''" style="width: auto;">
        <select v-model="displayModel" :id="id" class="select-contain-select" type="text" placeholder="" :title="label">
          <option v-for="option in optionList" :value="option[idKey]" v-bind:key="option[idKey]">{{ getOptionText(option) }}</option>
        </select>
        <small class="error-text">{{errors[0]}}</small>
      </div>
    </validation-provider>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import { alpha, required } from 'vee-validate/dist/rules';
import validationMethodsMixin from "../../mixin/validationMethodsMixin";

export default {
  name: "BaseSelectInput",
  mixins : [validationMethodsMixin],
  components : {ValidationProvider},
  data :() => {
    return {
      valid : null,
      displayModel : null,
      id: Math.floor(Math.random() * 10100)
    };
  },
  props : {
    href : null,
    textkey : {
      type: Array,
      default() {
        return ['name']
      }
    },
    idKey : {
      type: String,
      default() {
        return 'id'
      }
    },
    hrefText : null,
    label : null,
    optionList : null,
    type : String,
    rules : String,
    inputModel : null
  },
  model: {
    prop: 'inputModel',
    event: 'change'
  },
  mounted() {
    alpha.message =  'Not alpha numeric';
    extend("alpha", alpha);


    extend("required", {...required,
        message : required.message =  'Required'});

    this.displayModel = this.inputModel;
    this.$nextTick(()=>{
      $(".select-contain-select").selectpicker({
        size: 5,
        noneSelectedText: 'Select One'});
      $(".select-contain-select").selectpicker('refresh');
    })
  },
  watch: {
    displayModel: {
      handler: function () {
        this.$nextTick(()=>{
          $(".select-contain-select").selectpicker({
            size: 5,
            noneSelectedText: 'Select One'});
          $(".select-contain-select").selectpicker('refresh');
        })
      }
    },
    optionList:{
      handler:function (){
        let that = this;
        this.$nextTick(()=>{
          $(".select-contain-select").selectpicker({
            size: 5,
            noneSelectedText: 'Select One'});
          setTimeout(function (){
            $("#"+that.id).val(that.inputModel)
            $("#"+that.id).selectpicker('refresh');
          },1)
          $("#"+that.id).selectpicker('refresh');

        })
      }
    }
  },
  methods:{
    getOptionText(option){
      let optionText = "";
      // this.textkey.forEach()
      for(let i=0;i<this.textkey.length;i++){
        optionText += option[this.textkey[i]]+' ';
      }
      return optionText;
    }
  }
}
</script>

<style scoped>

</style>